export const baseNotificationFields = [
  'id',
  'title',
  'body',
  'path',
  'read',
  'entityId',
  'threadId',
  'entityName',
  'senderEntityName',
  'senderId',
  'userId',
  'profileImageBlobHash',
  'createdAt',
  'type',
];
